import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brazilian-jiu-jitsu',
  templateUrl: './brazilian-jiu-jitsu.component.html',
  styleUrls: ['./brazilian-jiu-jitsu.component.css']
})
export class BrazilianJiuJitsuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
